<template>
    <TemplatesEventsPage />
</template>
